import { Controller } from "@hotwired/stimulus"

// Toggles visibility of a reply form for an activity.
// Scoped to the turbo-frame wrapper for this specific activity (not a
// global id lookup) so it works correctly even when the same activity
// renders more than once on a page (e.g. a Card's activity appearing both
// on its parent Project's docked feed and inside a Card modal opened over
// that same page -- see card #3225).
export default class extends Controller {
  static targets = ["form"]

  toggle() {
    if (this.hasFormTarget) {
      this.formTarget.classList.toggle("hidden")
    }
  }
}
